import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MaterialCommunityIcons } from '../../utils/icons';
import './RatingsScreen.css';

const RatingsScreen: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="ratings-container">
      <div className="ratings-header">
        <button onClick={() => navigate('/')}>
          <MaterialCommunityIcons name="arrow-back" size={24} color="#FF006E" />
        </button>
        <h1>Ratings</h1>
      </div>
      <div className="ratings-content">
        <p>Ratings functionality coming soon...</p>
      </div>
    </div>
  );
};

export default RatingsScreen;

